
export const NET_BANKING_OPTIONS = 'NET_BANKING_OPTIONS';